import React, { useState, useEffect } from "react";
import { createStripeAccount, createAccountLink, accountStatus } from "../../services/profile.services";

export default function Home() {
  const [accountCreatePending, setAccountCreatePending] = useState(false);
  const [accountLinkCreatePending, setAccountLinkCreatePending] = useState(false);
  const [error, setError] = useState(false);
  const [connectedAccountId, setConnectedAccountId] = useState();

  const handleCreateAccount = async () => {
    setAccountCreatePending(true);
    setError(false);

    try {
      const response = await createStripeAccount();
      const { account, error: apiError } = response;

      if (account) {
        setConnectedAccountId(account);
        // Automatically create account link after account creation
        await handleCreateAccountLink(account);
      }

      if (apiError) {
        setError(true);
      }
    } catch (err) {
      console.error("Error creating Stripe account:", err);
      setError(true);
    } finally {
      setAccountCreatePending(false);
    }
  };

  const handleCreateAccountLink = async () => {
    setAccountLinkCreatePending(true);
    setError(false);

    try {
      const response = await createAccountLink(connectedAccountId);
      const { url, error: apiError } = response;

      if (url) {
        window.location.href = url;
      }

      if (apiError) {
        setError(true);
      }
    } catch (err) {
      console.error("Error creating account link:", err);
      setError(true);
    } finally {
      setAccountLinkCreatePending(false);
    }
  };

  useEffect(() => {
    (async function () {
      try {
        const { account_id, details_submitted, onboarding_complete, apiError } = await accountStatus();

        if (apiError) {
          setError(true);
          return;
        }

        if (account_id) {
          setConnectedAccountId(account_id);
          setAccountCreatePending(false);

          // If account exists but onboarding isn't complete, show "Add information"
          if (!onboarding_complete || !details_submitted) {
            setAccountLinkCreatePending(true);
          } else {
            setAccountLinkCreatePending(false);
          }
        }
      } catch (err) {
        console.error("Error fetching account status:", err);
        setError(true);
      }
    })();
  }, []);

  return (
    <div className="container" style={{ paddingLeft: "7rem", paddingTop: "2rem" }}>
      <div className="banner">
        <h2>Rocket Rides</h2>
      </div>
      <div className="content">
        {!connectedAccountId && <h2>Get ready for take off</h2>}
        {!connectedAccountId && <p>Rocket Rides is the world's leading air travel platform: join our team of pilots to help people travel faster.</p>}
        {connectedAccountId && <h2>Add information to start accepting money</h2>}
        {connectedAccountId && <p>Matt's Mats partners with Stripe to help you receive payments and keep your personal bank and details secure.</p>}

        {!accountCreatePending && !connectedAccountId && <button onClick={handleCreateAccount}>Create an account!</button>}

        {connectedAccountId && accountLinkCreatePending && <button onClick={handleCreateAccountLink}>Add information</button>}

        {error && <p className="error">Something went wrong!</p>}

        {(connectedAccountId || accountCreatePending || accountLinkCreatePending) && (
          <div className="dev-callout">
            {connectedAccountId && (
              <p>
                Your connected account ID is: <code className="bold">{connectedAccountId}</code>
              </p>
            )}
            {accountCreatePending && <p>Creating a connected account...</p>}
            {accountLinkCreatePending && <p>Creating a new Account Link...</p>}
          </div>
        )}

        <div className="info-callout">
          <p>
            This is a sample app for Stripe-hosted Connect onboarding.{" "}
            <a href="https://docs.stripe.com/connect/onboarding/quickstart?connect-onboarding-surface=hosted" target="_blank" rel="noopener noreferrer">
              View docs
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
